import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import { ZoomIn } from 'lucide-react'

interface CompleteTourImageProps {
  image: string
  title: string
  duration: string
  routeLength: number
  onImageClick: (image: string) => void
}

export function CompleteTourImage({ 
  image, 
  title, 
  duration, 
  routeLength, 
  onImageClick 
}: CompleteTourImageProps) {
  const { t } = useTranslation()
  
  return (
    <section className="py-12">
      <div className="max-w-7xl mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl font-bold text-foreground mb-4">{t('home.completeTourOverview')}</h2>
          <p className="text-muted-foreground">{t('home.experienceFullJourney')}</p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
          className="relative overflow-hidden rounded-2xl shadow-2xl group cursor-pointer"
          onClick={() => onImageClick(image)}
        >
          <img
            src={image}
            alt={`Complete ${title} overview`}
            className="w-full h-96 object-cover object-top group-hover:scale-105 transition-transform duration-300"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
          <div className="absolute bottom-6 left-6 text-white">
            <h3 className="text-2xl font-bold mb-2">{title}</h3>
            <p className="text-white/90">{duration} • {routeLength} destinations</p>
          </div>
          {/* Zoom Icon */}
          <div className="absolute top-4 right-4 p-2 bg-black/50 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            <ZoomIn className="h-6 w-6 text-white" />
          </div>
        </motion.div>
      </div>
    </section>
  )
}
